import { useState, useEffect } from "react";
import { Button, Input } from "antd";
import styled from "styled-components";
import { patchSlideData } from "../../api/slideAPI";
import { currentSlideAtom } from "../../atom";
import { useRecoilState } from "recoil";

interface TeachingTextAreaProps {
    slideId: number;
    initialContent?: string;
    reloadTeachingText: () => void;
}

const TeachingTextArea = ({slideId, initialContent = "", reloadTeachingText }: TeachingTextAreaProps) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [teachingContent, setTeachingContent] = useState<string>(initialContent);
    const [currentSlide, setCurrentSlide] = useRecoilState(currentSlideAtom);
    
    useEffect(()=>{ 
        reloadTeachingText();
    }, [])

    useEffect(() => {
        setTeachingContent(currentSlide?.description || initialContent);
    }, [initialContent, currentSlide?.description]);

    const handleEdit = () => {
        setIsEditMode(true);
    };

    const handleSave = async () => {
        if(!slideId) return;
        try {
            const requestData = {
                description: teachingContent,
                slideId
            } 
            await patchSlideData(requestData);
            setIsEditMode(false);
        } catch (error) {
            console.error("저장 실패:", error);
        }
    };

    const handleCancel = () => {
        setTeachingContent(initialContent);
        setIsEditMode(false);
    };

    return (
        <StTeachingTextContainer>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", height: "100%", overflowY: "auto" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                    <h3 style={{ margin: 0 }}>Teaching Notes</h3>
                    {isEditMode ? (
                        <>
                            <Button onClick={handleCancel}>Cancel</Button>
                            <Button type="primary" onClick={handleSave}>Save</Button>
                        </>
                    ) : (
                        <Button onClick={handleEdit}>Edit</Button>
                    )}
                </div>
                <Input.TextArea
                    value={teachingContent}
                    onChange={(e) => setTeachingContent(e.target.value)}
                    placeholder={isEditMode ? "실습 관련 내용을 입력하세요..." : ""}
                    rows={4}
                    readOnly={!isEditMode}
                    style={{
                        backgroundColor: isEditMode ? "#fff" : "#f5f5f5",
                        cursor: isEditMode ? "text" : "default"
                    }}
                />
            </div>
        </StTeachingTextContainer>
    );
};

export default TeachingTextArea;

const StTeachingTextContainer = styled.div`
  padding: 16px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
`;